import { render, staticRenderFns } from "./IconElementParagraph.vue?vue&type=template&id=1059fe18&"
import script from "./IconElementParagraph.vue?vue&type=script&lang=js&"
export * from "./IconElementParagraph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1059fe18')) {
      api.createRecord('1059fe18', component.options)
    } else {
      api.reload('1059fe18', component.options)
    }
    module.hot.accept("./IconElementParagraph.vue?vue&type=template&id=1059fe18&", function () {
      api.rerender('1059fe18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconElementParagraph.vue"
export default component.exports